import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ColorSchemePicker, Tabs } from '@platform/ui';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { ProfileAccount } from '../shell/ProfileAccount';
import { ProfilePins } from '../shell/ProfilePins';
import '../shell/profile.css';

const TABS = ['account', 'appearance', 'menu'];

/**
 * Профіль у робочому просторі (прототип v4): заголовок і вкладки «Обліковий запис» (ім'я, e-mail, роль, мова), «Вигляд» (25 світлих і 25 темних
 * колірних схем) і «Верхнє меню» (закріплені модулі простору, до 6). Вкладка — в адресі (?tab=): «Налаштування» меню профілю відкриває «Вигляд».
 */
export function ProfilePage() {
  const { t } = useTranslation();
  const { ws } = useWorkspaceParams();
  const [params, setParams] = useSearchParams();
  const tab = TABS.includes(params.get('tab') ?? '') ? params.get('tab')! : 'account';
  const setTab = (key: string) => setParams(key === 'account' ? {} : { tab: key }, { replace: true });
  const tabs = [{ key: 'account', label: t('profilePage.tabAccount') }, { key: 'appearance', label: t('profilePage.tabAppearance') }, { key: 'menu', label: t('profilePage.tabMenu') }];
  return (
    <div className="pf-page">
      <h1>{t('profilePage.title')}</h1>
      <Tabs tabs={tabs} active={tab} onChange={setTab} />
      {tab === 'account' && <ProfileAccount />}
      {tab === 'appearance' && <ColorSchemePicker />}
      {tab === 'menu' && <ProfilePins ws={ws} />}
    </div>
  );
}
